<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/qtbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'运维服务系统'"></detailBread>
        <div class="container">
            <div class="page-title">
                运维服务系统
            </div>
            <div class="page-content" style="text-align:left;width:1000px;margin:0 auto;">
                <div style=" text-indent: 32px; line-height: 24px; text-align: left;">
                    <p>我们每天浪费了多少时间，站在固定资产前抄写那一段毫无规律又字母和数字混杂的序列号？为了一个小问题，又花费了多少时间联系服务商，跟踪维修结果，这实在不值得！</p>
                    <p>理想中的运维服务是：从录入资产信息开始，资源管理系统化、管理远程化。自动监测报警、自动报修、跟踪服务状态、反馈结果。整个过程不用你动手，在你需要的时候就会自动现身。当这一切梦想都成为现实，你在还等什么呢？</p>
                    <p>“昂克运维服务系统”，不仅仅是一个软件，更是一个标准化服务的管理理念。它实现了资产管理监控和维修流程标准化、透明化的管理。支持本地部署和云平台，简单易用，提供移动端App。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">一、统一管理入口，固定资产盘点半自动化</p>
                    <p>“昂克运维服务系统”通过登记固定资产信息，对每一项固定资产进行唯一的编码，扫描资产唯一二维码，呈现资产信息。帮助简化资产盘点工作，做到盘点工作的半自动化。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">二、管用分离，服务器资源管理云化</p>
                    <p>“昂克运维服务系统”将资产的管理权和使用权分离，应用系统维护人员只需要关心服务器资源的使用，而无需亲自完成服务器资源的准备工作。设立专门的设备管理员角色来完成服务器资源的准备和维护工作，实现专业化分工和服务器资源管理的云化。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">三、固化流程，资源管理系统化</p>
                    <p>“昂克运维服务系统”将IP、机柜等采用Excel线下管理的资源，将其管理固化到系统中，降低手工管理带来的操作风险。将资源相关的申请、变更、上架、下架、入库、出库等流程固化到系统中，实现资源管理的系统化。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">四、管理远程化</p>
                    <p>“昂克运维服务系统”将管理界面拉到机房之外，在办公区域即可完成对设备的远程管理，除非必要的硬件更换需要到现场，大部分的管理和维护工作均可通过远程实现，减少管理的人力成本。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">五、维护智能化</p>
                    <p>“昂克运维服务系统”通过昂克大精灵、小精灵，获取设备基本信息，分析当前设备的运行状态，并以友好的界面展示设备的运行情况，供维护人员查看。主要服务器支持的机器型号如下：</p>
                    <table border="1" style="width:100%;">
                        <tr>
                            <td style="width: 120px; text-align: center;">惠普机型</td>
                            <td>HP DL360 G5、HP DL380 G5、HP DL580 G5、HP DL785 G5、HP BL460c G5、HP BL680c G5、HP DL360 G6、HP DL370 G6、HP DL380 G6、HP DL785 G6、HP BL460c G6、HP DL360 G7、HP DL380 G7、HP DL580 G7、HP DL980 G7、HP DL350 Gen8、HP DL360 Gen8、HP DL380 Gen8、HP DL580 Gen8、HP DL360 Gen9、HP DL380 Gen9、HP DL580 Gen9</td>
                        </tr>
                        <tr>
                            <td style="width: 120px; text-align: center;">曙光机型</td>
                            <td>I610-G10、I620-G10、I610-G15、I620-G15、I640-G15、I610-G20、I620-G20</td>
                        </tr>
                        <tr>
                            <td style="width: 120px; text-align: center;">Dell机型</td>
                            <td>PowerEdge 1950、2950、R200、R610、R620、R710、R720、R720xd、R730，R730xd、R910、M630</td>
                        </tr>
                    </table>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">六、数据准确化</p>
                    <p>“昂克运维服务系统”通过昂克大精灵、小精灵对硬件设备进行全方位的监控，通过底层获取设备准确的基础信息，资源管理数据的准确性。</p>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">七、巡检自动化</p>
                    <p>“昂克运维服务系统”采用24小时*365天自动巡检、定时巡检的方式，通过昂克大精灵、小精灵实时地对设备进行硬件级的监控，并自动上报巡检结果，及时解决设备故障。监测信息包括：</p>
                    <table border="1" style="width:100%;">
                        <tr>
                            <td style="width: 120px; text-align: center;">故障信息</td>
                            <td>
                                CPU、主板、内存、阵列卡、硬盘、HBA卡、电源、电池失效、风扇、网卡、等等
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 120px; text-align: center;">操作异常<br>行为信息</td>
                            <td>机器离线、机器人为重启、机器人为关机、插入移动存储设备、从服务器移走设备、等等</td>
                        </tr>
                        <tr>
                            <td style="width: 120px; text-align: center;">运行状态<br>及<br>隐患信息</td>
                            <td>风扇转速及阙值、机箱温度及阙值、CPU温度及阙值、主板电压及阙值、电源功率及阙值、日志满</td>
                        </tr>
                    </table>
                    <p style=" font-size: 18px; font-weight: bold;margin: 20px 0;">八、维修标准化</p>
                    <p>通过扫描资产二维码或者自动监控报警，可以实现快速报修。支持上传现场资料（图片、音视频等），方便了解资产问题。支持自动派单，明确维修任务，流程清晰明了。从报修到维修结束，每一步都有数据跟踪，方便把控维修进度和结果。</p>
                    <p>选择一个合适的运维服务平台，有效连接资产使用者和维护者，让我们专注于提高用户体验，提升服务质量。</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '运维服务系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '运维服务系统'
        },
        {
            name: 'description',
            content: '运维服务系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'3',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
.page-content p {
    text-indent: 32px;
    font-size: 16px;
    line-height: 30px;
}
td {
    padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/old/ywfwxt.vue